import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { API_TOKEN } from '../..';
import { ApiConstant } from '../../types';

const TRANSACTION_NAME = environment.elasticAPM.transactionName;

@Injectable({
    providedIn: 'root',
})
export class SimulationTypeService {
    baseUrl = `${this.apiConstants.endpoint}/SimulationType`;

    private getsSub$ = new Subject<any>();
    private getSub$ = new Subject<any>();
    private createSub$ = new Subject<any>();
    private deleteSub$ = new Subject<any>();

    constructor(@Inject(API_TOKEN) private apiConstants: ApiConstant, private httpClient: HttpClient) {}

    gets(): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Gets simulation type' });
        return this.httpClient
            .post(`${this.baseUrl}/Gets`, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getsSub$.next(result);
                    }
                }),
            );
    }

    getTypesByOrgId(id: number): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Gets simulation type' });
        return this.httpClient
            .get(`${this.baseUrl}/GetsByOrganizationId/${id}`, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getsSub$.next(result);
                    }
                }),
            );
    }

    get(): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get simulation type' });
        return this.httpClient
            .post(`${this.baseUrl}/Get`, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getSub$.next(result);
                    }
                }),
            );
    }

    create(dataInsert: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Create simulation type' });
        let rawData = {
            simulationTypeId: dataInsert.id,
            ...dataInsert,
        };
        return this.httpClient
            .post(`${this.baseUrl}/CreateSimulationType`, rawData, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.createSub$.next(result);
                    }
                }),
            );
    }

    update(id: number, dataInsert: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Create simulation type' });
        let rawData = {
            simulationTypeId: dataInsert.id,
            ...dataInsert,
        };
        return this.httpClient
            .put(`${this.baseUrl}/UpdateSimulationType/${id}`, rawData, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.createSub$.next(result);
                    }
                }),
            );
    }

    delete(id: any): Observable<any> {
        return this.httpClient.delete(`${this.baseUrl}/Delete/${id}`).pipe(
            tap(result => {
                if (result) {
                    this.deleteSub$.next(result);
                }
            }),
        );
    }

    setDefault(request: any): Observable<any> {
        return this.httpClient.post(`${this.baseUrl}/SetDefaultType`, request).pipe(
            tap(result => {
                if (result) {
                    this.getSub$.next(result);
                }
            }),
        );
    }

    getAll(): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get All simulation type' });
        return this.httpClient
            .post(`${this.baseUrl}/GetAll`, {
                headers,
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getSub$.next(result);
                    }
                }),
            );
    }
}
